import React from 'react';
import OrderCancelManagementListSearchBox from '../OrderCancelManagementListSearchBox';
import OrderCancelManagementList from '../OrderCancelManagementList';
import { _LIST_PAGINATION_MODEL } from '../../../../../../store/modules/app/models';
import {
  ORDER_CANCEL_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
  ORDER_CANCEL_MANAGEMENT_LIST_SEARCH_DATA_MODEL,
} from '../../../../../../store/modules/order/models';
import { SEARCH_PERIOD_BUTTON_ALL_TYPE } from '../../../../../../constants/service/common/utilConstants';

const OrderCancelManagementListWrap = (props) => {
  const {
    orderCancelManagement,
    setData,
    getList,
    onCheckOrderItem,
    getAllListExcelDownload,
    getSelectedListExcelDownload,
    rejectOrderCancel,
    getOrderCancelStockAndStatusList,
    rejectOrderCancelDeliveryDispatch,
  } = props;
  const { orderCancelManagementList, orderCancelManagementSelectedList } = orderCancelManagement;
  const {
    canceledDate,
    orderCancelStatusList,
    cancelAcceptManagerList,
    cancelManagerList,
    orderItemDetailSearch,
    productType,
    store,
  } = orderCancelManagementList.searchData;

  return (
    <div className="order-cancel-management-list-wrap">
      <OrderCancelManagementListSearchBox
        setData={(data) =>
          setData({
            path: ['orderCancelManagement', 'orderCancelManagementList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={orderCancelManagementList.searchData}
        onSearch={() =>
          getList({
            searchOption: {
              /**
               *  취소 요청 일시
               */
              canceledDate: canceledDate.quickDateIndex !== SEARCH_PERIOD_BUTTON_ALL_TYPE ? canceledDate.period : null,
              /**
               *  상품 주문 취소 상태 리스트
               */
              orderCancelStatusList,
              /**
               *  취소 접수자 리스트
               */
              cancelAcceptManagerList,
              /**
               *  취소 처리자 리스트
               */
              cancelManagerList,
              /**
               *  상세 검색
               */
              orderItemDetailSearch,
              /**
               *  상품 타입
               */
              productType,
              /**
               *  판매처
               */
              store,
            },
            pagination: _LIST_PAGINATION_MODEL,
          })
        }
        onClear={() => {
          getList({
            searchOption: ORDER_CANCEL_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
            pagination: _LIST_PAGINATION_MODEL,
          });
          setData({
            path: ['orderCancelManagement', 'orderCancelManagementList', 'searchData'],
            value: ORDER_CANCEL_MANAGEMENT_LIST_SEARCH_DATA_MODEL,
          });
        }}
      />

      <OrderCancelManagementList
        orderCancelManagementList={orderCancelManagementList}
        orderCancelManagementSelectedList={orderCancelManagementSelectedList}
        getList={getList}
        getAllListExcelDownload={getAllListExcelDownload}
        getSelectedListExcelDownload={getSelectedListExcelDownload}
        onCheckOrderItem={onCheckOrderItem}
        rejectOrderCancel={rejectOrderCancel}
        getOrderCancelStockAndStatusList={getOrderCancelStockAndStatusList}
        rejectOrderCancelDeliveryDispatch={rejectOrderCancelDeliveryDispatch}
      />
    </div>
  );
};

export default OrderCancelManagementListWrap;
